
/* eslint-disable import/prefer-default-export */
import { useState } from 'react';

export const useCurrentModal = (initialValue = false) => {
  const [isOpenCurrentModal, setIsOpenCurrentModal] = useState(initialValue);
  const [nameCurrentModal, setNameCurrentModal] = useState('')

  const openCurrentModal = (modalName) => {
    setIsOpenCurrentModal(true);
    setNameCurrentModal(modalName)
  }

  const closeCurrentModal = () => {
    setIsOpenCurrentModal(false);
    setNameCurrentModal('')
  }

  return [isOpenCurrentModal, nameCurrentModal, openCurrentModal, closeCurrentModal];
};
